/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { createContext, useState } from "react";
import { FooterNav } from "components/Local/FooterNav/FooterNav";
import { Stuffing } from "components/Local/Stuffing/Stuffing";
import { Images, useStuffingHook } from "pages/hooks/Stuffing.hook";
import { RouteType } from "../App";

export type ErrorMessages = {
  group: string;
  message: string;
};

export type StuffingInitialData = {
  data: any;
  errorMessages: ErrorMessages[];
};

interface StuffingPageTypes {
  setRoute: (page: RouteType) => void;
  initialStuffing: StuffingInitialData;
}

export const ImageContext = createContext<Images>({});

export const StuffingPage = ({ setRoute, initialStuffing }: StuffingPageTypes) => {
  const [stuffingData] = useState<any>(initialStuffing.data);
  const [errorMessages] = useState<ErrorMessages[]>(initialStuffing.errorMessages);
  const [images, setImages] = useState<Images>({});

  const { loadImages, loadAllPages, loadMore } = useStuffingHook(
    initialStuffing.data?.result ? initialStuffing.data : null
  );

  const pageHandler = (page: number) => {
    void loadImages(page, (partial) => {
      setImages((state) => ({ ...state, ...partial }));
    }).then((nextImages) => {
      setImages((state) => ({ ...state, ...nextImages }));
    });
  };

  const generatePdf = async () => {
    let data = {};

    await new Promise((resolve) =>
      setTimeout(async () => {
        await loadAllPages().then((res) => {
          setImages((state) => ({ ...state, ...res }));
          data = res;
        });
        resolve("");
      }, 0)
    );

    return data;
  };

  return (
    <ImageContext.Provider value={images}>
      <Stuffing pageHandler={pageHandler} errorMessages={errorMessages} stuffingData={stuffingData} />

      <FooterNav
        page="stuffing"
        linkBack="container"
        linkNext=""
        setRoute={setRoute}
        // @ts-ignore
        generatePdf={generatePdf}
        loadMore={loadMore}
      />
    </ImageContext.Provider>
  );
};
